import React from 'react';

import { PlanFeatureGate } from 'components';
import {
  AnonymsView,
  ApiDocs,
  AppContainer,
  AuthCallback,
  BanksList,
  CheckDesigner,
  Dashboard,
  EmptyStub,
  Login,
  MainContainer,
  MainView,
  MembersList,
  NotFoundPage,
  OrganizationDetailPage,
  OrganizationList,
  PayeeList,
  PaymentDetail,
  PaymentList,
  PrintECheck,
  ResetPassword,
  Settings,
  SuperAdminPage,
  UserForgotPassword,
  UserPayeeList,
  UserPaymentList,
  UserProfile,
  UserRegister,
  VerifyCheck,
  VerifyCheckResult,
} from 'features';

import { Route } from 'third-party';

import {
  apiSpecUrl,
  appUrl,
  auditUrl,
  authCallbackUrl,
  bankCheckListUrl,
  bankListUrl,
  forgotPasswordUrl,
  loginUrl,
  memberListUrl,
  notFoundUrl,
  organizationDashboardUrl,
  organizationListUrl,
  payeeListUrl,
  paymentListUrl,
  printAnonECheckUrl,
  printECheckUrl,
  registerUrl,
  resetPasswordUrl,
  resetUserPasswordUrl,
  settingsTabUrl,
  settingsUrl,
  superAdminOrganizationUrl,
  superAdminUrl,
  userActivityListUrl,
  userFormUrl,
  userOrganizationPayeeListUrl,
  userOrganizationPaymentListUrl,
  userPayeeListUrl,
  userPaymentDetailsUrl,
  userPaymentListUrl,
  userPaymentOrganizationDetailsUrl,
  userProfileUrl,
  verifyCheckUrl,
  verifyCheckWithIdUrl,
} from 'constants/url';

import { AuditsList } from 'features/Audit/AuditList';

import { PlanFeature, SettingsTab } from 'types/app';

export const useRoutes = () => {
  return (
    <Route path={appUrl()} element={<MainContainer />}>
      {/* anonyms  routes */}
      <Route path={authCallbackUrl()} element={<AuthCallback />} />
      <Route path={resetPasswordUrl()} element={<AnonymsView />}>
        <Route
          path={resetUserPasswordUrl(':email', ':token')}
          element={<ResetPassword />}
        />
      </Route>

      <Route path={verifyCheckUrl()} element={<AnonymsView />}>
        <Route path={verifyCheckUrl()} element={<VerifyCheck />} />
        <Route
          path={verifyCheckWithIdUrl(':code')}
          element={<VerifyCheckResult />}
        />
      </Route>

      <Route path={printECheckUrl()} element={<AnonymsView />}>
        <Route
          path={printAnonECheckUrl(':eCheckId')}
          element={<PrintECheck />}
        />
      </Route>

      <Route path={appUrl()} element={<AppContainer />}>
        <Route path={userFormUrl()} element={<AnonymsView />}>
          <Route path={registerUrl()} element={<UserRegister />} />
          <Route path={forgotPasswordUrl()} element={<UserForgotPassword />} />
          <Route path={loginUrl()} element={<Login />} />
        </Route>

        <Route path={appUrl()} element={<MainView />}>
          {/* user routes */}
          <Route path={userProfileUrl()} element={<UserProfile />} />
          <Route path={userPaymentListUrl()} element={<UserPaymentList />} />
          <Route path={organizationListUrl()} element={<OrganizationList />} />
          <Route path={userPayeeListUrl()} element={<UserPayeeList />} />
          <Route path={superAdminUrl()} element={<SuperAdminPage />} />
          <Route
            path={superAdminOrganizationUrl(':organizationId')}
            element={<OrganizationDetailPage />}
          />
          <Route
            path={userPaymentDetailsUrl(':paymentId')}
            element={<PaymentDetail />}
          />

          {/* organization routes */}
          <Route
            path={userProfileUrl(':organizationId')}
            element={<UserProfile />}
          />
          <Route
            path={apiSpecUrl(':organizationId')}
            element={
              <PlanFeatureGate feature={PlanFeature.ApiAccess}>
                <ApiDocs />
              </PlanFeatureGate>
            }
          />
          <Route
            path={userOrganizationPaymentListUrl(':organizationId')}
            element={<UserPaymentList />}
          />
          <Route path={auditUrl(':organizationId')} element={<AuditsList />} />

          <Route
            path={userOrganizationPayeeListUrl(':organizationId')}
            element={<UserPayeeList />}
          />

          <Route
            path={userPaymentOrganizationDetailsUrl(
              ':organizationId',
              ':paymentId',
            )}
            element={<PaymentDetail />}
          />
          <Route
            path={organizationDashboardUrl(':organizationId')}
            element={<Dashboard />}
          />
          <Route
            path={paymentListUrl(':organizationId')}
            element={<PaymentList />}
          />
          <Route
            path={payeeListUrl(':organizationId')}
            element={<PayeeList />}
          />
          <Route
            path={bankListUrl(':organizationId')}
            element={<BanksList />}
          />
          <Route
            path={bankCheckListUrl(':organizationId', ':bankId')}
            element={
              <PlanFeatureGate feature={PlanFeature.CheckDesigner}>
                <CheckDesigner />
              </PlanFeatureGate>
            }
          />
          <Route
            path={memberListUrl(':organizationId')}
            element={<MembersList />}
          />
          <Route
            path={userActivityListUrl(':organizationId')}
            element={<EmptyStub />}
          />
          <Route path={settingsUrl(':organizationId')} element={<Settings />} />
          <Route
            path={settingsTabUrl(':organizationId', ':tab' as SettingsTab)}
            element={<Settings />}
          />
        </Route>
      </Route>

      <Route path={notFoundUrl()} element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  );
};
